import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Assigning a Chapter",
    intro: "Each Project Explore chapter has a story at four tiers, in English and Spanish.",
    steps: [
      "In your teacher dashboard, choose Assign PE Chapter.",
      "Pick the chapter.",
      "Pick the tier: T1 (K and 1st grade), T2 (2nd grade), T3 (3rd grade) or T4 (4th and 5th grade).",
      "Pick the language: English or Spanish.",
      "Choose the entire class or individual students.",
      "Set the start and due dates and times. You can add instructions if you like.",
      "Choose Assign Chapter.",
    ],
    tip: "Students see the chapter on their dashboard and open it with Start.",
  },
  es: {
    title: "Cómo asignar un capítulo",
    intro: "Cada capítulo de Project Explore tiene un cuento en cuatro niveles, en inglés y en español.",
    steps: [
      "En tu panel de maestro, elige Asignar un capítulo.",
      "Elige el capítulo.",
      "Elige el nivel: T1 (kínder y 1.er grado), T2 (2.º grado), T3 (3.er grado) o T4 (4.º y 5.º grado).",
      "Elige el idioma: inglés o español.",
      "Elige toda la clase o algunos estudiantes.",
      "Pon las fechas y horas de inicio y de entrega. Si quieres, agrega instrucciones.",
      "Elige Assign Chapter (Asignar el capítulo).",
    ],
    tip: "Los estudiantes ven el capítulo en su panel y lo abren con Empezar.",
  },
};

export default function AssigningActivities() {
  return <HelpArticle text={TEXT} />;
}
